module.exports = __webpack_public_path__ + "img/card_top_bg.dc17d1a4.png";